<div class="footer-wrapper">
    <div *ngIf="locale === 'en-us'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                <a href="javascript: void(0)" target="_self">
                <span class="country-select">USA - United States</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/contact" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>



    <div *ngIf="locale === 'en-au'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">AU - AUSTRALIA</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-au/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-au/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-au/contact" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>


    <div *ngIf="locale === 'en-gb'"  class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">UK - United Kingdom</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.co.uk/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="http://www.nvidia.co.uk/object/legal-info-uk.html" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.co.uk/contact/europe/" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'en-ca'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">CA - CANADA</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/contact/" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'pl-pl'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">PL - POLAND</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.pl/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Polityka Prywatnosci</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/pl-pl/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span>Informacje Prawne</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.pl/contact/europe/" target="_blank" rel="noopener">
                    <span>Kontakt</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'fr-ca'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">CA - CANADA</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Confidentialité</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span>Mentions légales</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-us/contact/" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>


    <div *ngIf="locale === 'fr-fr'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">FR - France</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.fr/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Confidentialité</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.fr/object/legal-info-fr.html" target="_blank" rel="noopener">
                    <span>Mentions légales</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.fr/contact/europe/" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'de-de'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">DE - Deutschland</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.de/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Datenschutz</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.de/object/legal-info-de.html" target="_blank" rel="noopener">
                    <span>Rechtliche Angaben</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.de/contact/europe/" target="_blank" rel="noopener">
                    <span>Kontakt</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'es-es'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">ES- ESPAÑA</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-es/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Política de privacidad</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-es/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span>Información legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-es/contact/europe/" target="_blank" rel="noopener">
                    <span>Contactar</span>
                </a>
            </div>
        </div>
    </div>

    <div *ngIf="locale === 'es-mx'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">ES- ESPAÑA</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-la/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Política de privacidad</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-la/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span>Información legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/es-la/contact/europe/" target="_blank" rel="noopener">
                    <span>Contactar</span>
                </a>
            </div>
        </div>
    </div>



    <div *ngIf="locale === 'ru-ru'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">RU - Россия</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.ru/object/privacy-policy-ru.html" target="_blank" rel="noopener">
                    <span>Положение о конфиденциальности</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="http://www.nvidia.ru/object/legal-info-ru.html" target="_blank" rel="noopener">
                    <span>Юридическая информация</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="http://www.nvidia.ru/object/contact-information-europe-ru.html" target="_blank" rel="noopener">
                    <span>Связаться с нами</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'nl-nl'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">NL - Netherlands</span>
                 </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/nl-nl/about-nvidia/privacy-policy/" target="_blank" rel="noopener">
                    <span>Privacybeleid</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-gb/about-nvidia/legal-info/" target="_blank" rel="noopener">
                    <span> Juridische informatie</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-gb/contact/" target="_blank" rel="noopener">
                    <span>Contact met ons op</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'it-it'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">IT - ITALIA</span>
                 </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/it-it/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/it-it/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>Note Legali</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/it-it/contact" target="_blank" rel="noopener">
                    <span>Contatti</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'pt-br'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                 <a href="javascript: void(0)" target="_self">
                <span class="country-select">BR - BRAZIL</span>
                 </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/pt-br/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Privacidade</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/pt-br/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/pt-br/contact" target="_blank" rel="noopener">
                    <span>Contato</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'zh-tw'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                <a href="javascript: void(0)" target="_self">
                <span class="country-select">TW - Taiwan</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/zh-tw/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>隱私權</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/zh-tw/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>合法的</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/zh-tw/contact" target="_blank" rel="noopener">
                    <span>聯絡</span>
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="locale === 'en-sg'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                <a href="javascript: void(0)" target="_self">
                <span class="country-select">SG - Singapore</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/{{locale}}/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Privacy</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-sg/legal-info/" target="_blank" rel="noopener">
                    <span>Legal</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/{{locale}}/contact" target="_blank" rel="noopener">
                    <span>Contact</span>
                </a>
            </div>
        </div>
    </div>
  
<div *ngIf="locale === 'fi-fi'" class="footer-inner">
    <div class="left-links">
        <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
            <a href="javascript: void(0)" target="_self">
            <span class="country-select">FI - SUOMI</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/{{locale}}/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                <span>Tietosuoja</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/about-nvidia/legal-info" target="_blank" rel="noopener">
                <span>Oikeudelliset tiedot</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/contact" target="_blank" rel="noopener">
                <span>Ota yhteyttä</span>
            </a>
        </div>
    </div>
</div>

<div *ngIf="locale === 'nb-no'" class="footer-inner">
    <div class="left-links">
        <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
            <a href="javascript: void(0)" target="_self">
            <span class="country-select">NO - NORGE</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/{{locale}}/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                <span>Personvern</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/about-nvidia/legal-info" target="_blank" rel="noopener">
                <span>Juridisk</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/contact" target="_blank" rel="noopener">
                <span>Kontakt</span>
            </a>
        </div>
    </div>
</div>



<div *ngIf="locale === 'da-dk'" class="footer-inner">
    <div class="left-links">
        <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
            <a href="javascript: void(0)" target="_self">
            <span class="country-select">DK - DANMARK</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/{{locale}}/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                <span>Personlige oplysninger</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/about-nvidia/legal-info" target="_blank" rel="noopener">
                <span>Juridiske oplysninger</span>
            </a>
        </div>
        <div class="footer-item">
            <a href="https://www.nvidia.com/en-gb/contact" target="_blank" rel="noopener">
                <span>Kontakt</span>
            </a>
        </div>
    </div>
</div>

    <div *ngIf="locale === 'sv-se'" class="footer-inner">
        <div class="left-links">
            <div class="footer-item" role="button" aria-pressed="true" (click)="openModal('countries')">
                <a href="javascript: void(0)" target="_self">
                <span class="country-select">SE - SVERIGE</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/{{locale}}/about-nvidia/privacy-policy" target="_blank" rel="noopener">
                    <span>Sekretess</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-gb/about-nvidia/legal-info" target="_blank" rel="noopener">
                    <span>Juridisk information</span>
                </a>
            </div>
            <div class="footer-item">
                <a href="https://www.nvidia.com/en-gb/contact" target="_blank" rel="noopener">
                    <span>Kontakta</span>
                </a>
            </div>
        </div>
    </div>
</div>

<modal id="countries" (click)="closeOverlay($event, par)" (window:keyup)="closeOverlay($event, par)">
    <div class="modal" #par>
        <div class="modal-body">
            <div class="modal-header">
                <div class="modal-header-text">SELECT YOUR LOCATION</div>
                <span class="modal-close" (click)="closeModal('countries');"></span>
            </div>
            <ul class="modal-country-list">
                <li *ngFor="let regionAndCountryList of regionsAndCountriesList" class="modal-region">
                    <span class="modal-country-text">
                        <div class="gf-sub-title">{{regionAndCountryList.region}}</div>
                <li *ngFor="let countryList of regionAndCountryList.countries" class="modal-country">
                    <span class="modal-country-text">
                        <a href="{{countryList.storeUrl}}">
                            <span class="country-line-1">{{countryList.country1}}</span>
                            <span class="country-line-2"><br>{{countryList.country2}}</span>
                        </a>
                    </span>
                </li>
                </span>
                </li>

            </ul>
        </div>
    </div>
    <div #cs id="cs" class="modal-background"></div>
</modal>
